module.exports = __webpack_public_path__ + "img/delete-outline-icon.15ca2d2.svg";